export const WordpressTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },

  query() {
    return {
      integration: 'wordpress'
    };
  }

};